/** unresolved 과업 */
export const UnresolvedAssignmentType = {
    /** 정보 다시 불러오기 */
    RELOAD: 'RELOAD',
} as const

/** 판매 과업 */
export const SaleAssignmentType = {
    /** 주문확인 */
    CHECK_ORDER: 'CHECK_ORDER',
    /** 발송처리 */
    DISPATCH: 'DISPATCH',
    /** 방문택배예약 > 정상발송처리 */
    BOOKING_VISIT_DELIVERY_DISPATCH: 'BOOKING_VISIT_DELIVERY_DISPATCH',
    /** 방문택배예약 > 취소거부 + 발송처리 */
    BOOKING_VISIT_DELIVERY_CANCEL_REJECT: 'BOOKING_VISIT_DELIVERY_CANCEL_REJECT',
    /** 편의점택배예약 */
    BOOKING_CONVENIENCE_STORE_DELIVERY: 'BOOKING_CONVENIENCE_STORE_DELIVERY',
    /** 판매거부 */
    SALE_REJECT: 'SALE_REJECT',
    /** 취소승인 */
    CANCEL_ADMISSION: 'CANCEL_ADMISSION',
    /** 취소거부 */
    CANCEL_REJECT: 'CANCEL_REJECT',
    /** 배송조회 */
    TRACK_DELIVERY: 'TRACK_DELIVERY',
    /** 수거수락 */
    COLLECTION_ADMISSION: 'COLLECTION_ADMISSION',
    /** 반품승인 */
    RETURN_ADMISSION: 'RETURN_ADMISSION',
    /** 반품거부 */
    RETURN_REJECT: 'RETURN_REJECT',
    /** 정보 다시 불러오기 */
    RELOAD: 'RELOAD',
} as const

export const isSaleAssignmentType = (type: AssignmentTypeType): type is Constant<typeof SaleAssignmentType> => {
    return type in SaleAssignmentType
}

/** 정산 과업 */
export const SettlementAssignmentType = {
    /** 판매상세 보기 */
    NAVIGATE_SALE_DETAIL: 'NAVIGATE_SALE_DETAIL',
}

export const isSettlementAssignmentType = (
    type: AssignmentTypeType,
): type is Constant<typeof SettlementAssignmentType> => {
    return type in SettlementAssignmentType
}

/** 결제 이후 과업 */
export const AfterPaymentAssignmentType = {
    /** 포인트 뽑기 */
    POINT_PICK: 'POINT_PICK',
    /** 포인트 받기 */
    RECEIVE_POINT: 'RECEIVE_POINT',
}

export const AssignmentType = {
    ...UnresolvedAssignmentType,
    ...SaleAssignmentType,
    ...SettlementAssignmentType,
    ...AfterPaymentAssignmentType,
} as const
export type AssignmentTypeType = Constant<typeof AssignmentType>

export type Assignment = {
    name: string
    /** 과업 타입 */
    type: Constant<typeof AssignmentType>
    /** 이동할 URL */
    url?: string
    /** 과업별 추가 데이터 (개선 필요) */
    value?: {
        deliveryNo?: string
    }
}
